import { RequestKind, boolean, string } from '@sb/library/base';
import {
    DisplayItemCollection,
    PracticeLogDisplayItem,
    PracticeLogDurationDisplayItem,
    PracticeLogFeedbackNotificationInputItem,
    PracticeLogFeedbackUpdateItem,
    PracticeLogInputItem,
    PracticeLogNotificationInputItem,
    PracticeLogSearchOptions,
    PracticeLogSettingsDisplayItem,
    PracticeLogSettingsUpdateItem,
    PracticeLogSummaryDisplayItem,
    PracticeLogSummarySearchOptions,
    PracticeLogUpdateItem
} from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace PracticeLogRoutes {
    export const Add = ApiRoute.Define({
        URL: `practicelogs`,
        Kind: RequestKind.Post,
        BodyType: PracticeLogInputItem,
        ResultType: string
    });

    export const Notify = ApiRoute.Define({
        URL: (practiceLogID: string) => `practicelogs/${practiceLogID}/notify`,
        Kind: RequestKind.Post,
        BodyType: PracticeLogNotificationInputItem,
        ResultType: boolean
    });

    export const Update = ApiRoute.Define({
        URL: (practiceLogID: string) => `practicelogs/${practiceLogID}`,
        Kind: RequestKind.Put,
        BodyType: PracticeLogUpdateItem
    });

    export const Delete = ApiRoute.Define({
        URL: (id: string) => `practicelogs/${id}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const Get = ApiRoute.Define({
        URL: (id: string) => `practicelogs/${id}`,
        Kind: RequestKind.Get,
        ResultType: PracticeLogDisplayItem
    });

    export const GetForStudent = ApiRoute.Define({
        URL: (studentID: string) => `students/${studentID}/practicelogs`,
        Kind: RequestKind.Get,
        ResultType: PracticeLogDisplayItem
    });

    export const GetAsSubstitute = ApiRoute.Define({
        URL: (eventID: string, studentID: string) => `event/${eventID}/student/${studentID}/practicelogs`,
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection
    });

    export const GetDurationPerDay = ApiRoute.Define({
        URL: `summary/dayspracticed`,
        Kind: RequestKind.Post,
        ResultType: Array<PracticeLogDurationDisplayItem>
    });

    export const GetSummary = ApiRoute.Define({
        URL: `summary/practicelogs`,
        Kind: RequestKind.Post,
        BodyType: PracticeLogSummarySearchOptions,
        ResultType: Array<PracticeLogSummaryDisplayItem>
    });

    export const Search = ApiRoute.Define({
        URL: `search/practicelogs`,
        Kind: RequestKind.Post,
        PagingAllowed: true,
        BodyType: PracticeLogSearchOptions,
        ResultType: DisplayItemCollection<PracticeLogDisplayItem>
    });

    export namespace Attachment {
        export const Add = ApiRoute.Define({
            URL: (practiceLogID: string) => `practicelogs/${practiceLogID}/attachments`,
            Kind: RequestKind.Post,
            BodyType: FormData,
            ResultType: string
        });

        export const Delete = ApiRoute.Define({
            URL: (practiceLogAttachmentID: string, practiceLogID: string) => `practicelogs/${practiceLogID}/attachments/${practiceLogAttachmentID}`,
            Kind: RequestKind.Delete,
            ResultType: boolean
        });
    }

    export namespace Settings {
        export const Get = ApiRoute.Define({
            URL: (studentID: string) => `students/${studentID}/practicelogsettings`,
            Kind: RequestKind.Get,
            ResultType: PracticeLogSettingsDisplayItem
        });

        export const Update = ApiRoute.Define({
            URL: 'practicelogsettings',
            Kind: RequestKind.Put,
            BodyType: PracticeLogSettingsUpdateItem,
            ResultType: boolean
        });
    }

    export namespace Feedback {
        export const Update = ApiRoute.Define({
            URL: (id: string) => `practicelogs/${id}/feedback`,
            Kind: RequestKind.Patch,
            BodyType: PracticeLogFeedbackUpdateItem,
            ResultType: boolean
        });

        export const Notify = ApiRoute.Define({
            URL: (id: string) => `practicelogs/${id}/notifyFeedback`,
            Kind: RequestKind.Post,
            BodyType: PracticeLogFeedbackNotificationInputItem,
            ResultType: boolean
        });
    }
}
